import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';

import { InfoPanelComponent } from '../../../shared/info-panel/info-panel.component';
import { InfoPanelExpansionSectionComponent } from '../../../shared/info-panel/expansion-section-component/info-panel-expansion-section.component';
import { InfoPanelFieldComponent } from '../../../shared/info-panel/field-component/info-panel-field.component';
import { SampleData } from '../../../interfaces/sample-test-panel';
import { InfoPanelSectionComponent } from '../../../shared/info-panel/section-component/info-panel-section.component';
import { UtcDatePipe } from '../../../shared/pipes/utc-date.pipe';
import { InfoPanelListFieldComponent } from '../../../shared/info-panel/list-field-component/info-panel-list-field.component';

@Component({
  selector: 'app-sample-info-panel',
  standalone: true,
  imports: [
    InfoPanelComponent,
    InfoPanelSectionComponent,
    InfoPanelExpansionSectionComponent,
    InfoPanelFieldComponent,
    UtcDatePipe,
    InfoPanelListFieldComponent,
  ],
  templateUrl: './sample-info-panel.component.html',
})
export class SampleInfoPanelComponent {
  @ViewChildren(InfoPanelExpansionSectionComponent) private sections!: QueryList<InfoPanelExpansionSectionComponent>;

  /** The raw sample info response, rendered as-is (same fields the old Get Info modal showed). */
  @Input() sample: SampleData | null = null;
  private _isOpen = false;
  @Input() set isOpen(value: boolean) {
    this._isOpen = value;
    if (!value) {
      setTimeout(() => this.sections?.forEach((s) => s.reset()), 225);
    }
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  @Output() closed = new EventEmitter<void>();

  get title(): string {
    return this.sample ? $localize`Sample #${this.sample.sampleId}` : $localize`Sample`;
  }

  get groups(): string[] {
    return this.sample?.groups.map((group) => group.groupName) ?? [];
  }
}
